<template>
    <div class="sinup">
        <el-form :model="ruleForm"
                 status-icon
                 :rules="rules"
                 ref="ruleForm"
                 label-width="70px"
                 class="form">
            <el-form-item prop="email" label="邮箱">
                <el-input v-model="ruleForm.email" clearable></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="pass">
                <el-input type="password" v-model="ruleForm.pass" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
                <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-row>
                <el-button type="primary" @click="submitForm('ruleForm')" :disabled="disable">注册</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import request from "../../common/request";
import api from "../../common/api";

export default {
    name: "Signup",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.ruleForm.checkPass !== '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                pass: '',
                checkPass: '',
                email: ''
            },
            rules: {
                email: [
                    {required: true, message: '请输入邮箱地址', trigger: 'blur'},
                    {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
                ],
                pass: [
                    {validator: validatePass, trigger: 'blur'}
                ],
                checkPass: [
                    {validator: validatePass2, trigger: 'blur'}
                ],
            },
            disable: false
        };
    },
    methods: {
        submitForm(formName) {
            this.disable = true
            setTimeout(() => {
                this.disable = false
            }, 1000)

            this.$refs[formName].validate((valid) => {
                if (valid) {
                    request.post(api.SignUp, this.ruleForm).then((data) => {
                        this.$message.success("注册成功")
                        this.$router.push({name: "Signin"})
                    })
                } else {
                    this.$message.error("参数错误")
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
}
</script>

<style scoped>
.sinup {
    display: flex;
    justify-content: center;
    margin-top: 150px;
    text-align: center;
    /*align-items: center;*/
    /*width: 100%;*/
    /*height: 100%;*/
}

.form {
    width: 300px;
    border: 1px solid #ebebeb;
    border-radius: 3px;
    transition: .2s;
    padding: 20px;
}
</style>
